export function getNextSort(currentSort, field) {
  if (!currentSort || currentSort.field !== field || !currentSort.direction) {
    return { field, direction: 'desc' }
  }

  if (currentSort.direction === 'desc') {
    return { field, direction: 'asc' }
  }

  return { field, direction: null }
}

function getSortValue(row, field) {
  if (field?.startsWith('comparison:')) {
    const id = field.split(':')[1]
    return row.comparisons.find((cell) => cell.id === id)?.delta ?? null
  }

  return row[field] ?? null
}

export function sortHoldingRows(rows, sort) {
  if (!sort?.field || !sort.direction) {
    return [...rows]
  }

  const direction = sort.direction === 'asc' ? 1 : -1

  return [...rows].sort((a, b) => {
    const aValue = getSortValue(a, sort.field)
    const bValue = getSortValue(b, sort.field)

    if (aValue == null && bValue == null) return 0
    if (aValue == null) return 1
    if (bValue == null) return -1

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return (aValue - bValue) * direction
    }

    return String(aValue).localeCompare(String(bValue), 'zh-Hant') * direction
  })
}
